import { render, staticRenderFns } from "./singleChoiceExam.vue?vue&type=template&id=17199960&"
import script from "./singleChoiceExam.vue?vue&type=script&lang=js&"
export * from "./singleChoiceExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports